<template>
  <ul class="my-0 list-unstyled">
    <matches v-if="!isEmpty(matches)"
      :matches="matches"
      view="popover"
    />

    <li v-if="!isEmpty(data.official_title)" class="row-content row-content_text--large mt-2">
      <span class="row-content--main">
        <span class="t-500">Official Title:</span>
        <span>{{ data.official_title }}</span>
      </span>
    </li>

    <li v-if="!isEmpty(data.population_ages)" class="row-content row-content_text--large mt-2">
      <span class="row-content--main">
        <span class="t-500">Age Group:</span>
        <span>{{ data.population_ages | separateByComma('population_age')}}</span>
      </span>
    </li>

    <li v-if="!isEmpty(data.diseases)" class="row-content row-content_text--large mt-2">
      <span class="row-content--main" v-line-clamp="4">
        <span class="t-500">Conditions/Diseases:</span>
        <span>{{data.diseases | separateByComma('term')}}</span>
      </span>
    </li>

    <li v-if="!isEmpty(data.interventions)" class="row-content row-content_text--large mt-2">
      <span class="row-content--main" v-line-clamp="4">
        <span class="t-500">{{'Intervention' | pluralize(data.interventions)}}: </span>
        <span>{{data.interventions | separateByComma('name')}}</span>
      </span>
    </li>

    <li v-if="description" class="row-content row-content_text--large">
      <span
        class="row-content--main"
        v-html="description"
        v-line-clamp="4"
      />
    </li>
  </ul>
</template>

<script>
import processing from '@/mixins/search/results/clinicalTrial'

import Matches from '@/components/search/results/partials/Matches'

export default {
  name: 'clinicalTrialResultPopover',
  mixins: [processing],
  components: {
    Matches
  },
  mounted () {
    if (
      !this.isEmpty(this.matches) ||
      !this.isEmpty(this.data.official_title) || !this.isEmpty(this.data.population_ages) ||
      !this.isEmpty(this.data.diseases) || !this.isEmpty(this.data.interventions) ||
      this.description
    ) {
      this.$emit('setIsEmptyPopover', false)
    } else {
      this.$emit('setIsEmptyPopover', true)
    }
  }
}
</script>
